import { render, staticRenderFns } from "./TestResult.vue?vue&type=template&id=035af97b&scoped=true"
import script from "./TestResult.vue?vue&type=script&lang=js"
export * from "./TestResult.vue?vue&type=script&lang=js"
import style0 from "./TestResult.vue?vue&type=style&index=0&id=035af97b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035af97b",
  null
  
)

export default component.exports